module.exports = __webpack_public_path__ + "img/pic3.90d0510f.png";